/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { AddThesisResponse, AddThesisVars } from '../openapi-types.gen.js';

export type { AddThesisResponse, AddThesisVars } from '../openapi-types.gen.js';

export const useAddThesis = createMutationHook<AddThesisVars, AddThesisResponse, unknown>({
  specName: 'useAddThesis',
  path: '/v1/theses',
  method: 'POST',
  resolveUrl: (vars: AddThesisVars) => `/v1/theses`,
  buildBody: (vars: AddThesisVars) => ({ signature: vars.signature, market: vars.market, outcomeIndex: vars.outcomeIndex, content: vars.content }),
  parseResponse: (raw: unknown): AddThesisResponse => raw as AddThesisResponse,
  
  
  
});
